import * as Localization from 'expo-localization'

export const DEFAULT_TIMEZONE = Localization.timezone
